<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-select
    aria-label="Week of the month"
    [(ngModel)]="week"
    (ngModelChange)="emitValue()"
    [disabled]="disabledByFieldset"
  >
    <mat-option [value]="0">First</mat-option>
    <mat-option [value]="1">Second</mat-option>
    <mat-option [value]="2">Third</mat-option>
    <mat-option [value]="3">Fourth</mat-option>
    <mat-option [value]="4">Fifth</mat-option>
    <mat-option [value]="5">Last</mat-option>
  </mat-select>
</mat-form-field>
